import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ToggleSwitch from 'giro-react-toolkit/source/ToggleSwitch';

import './Concept.scss';

/**
 * Component used to select a network concept.
 */
class Concept extends Component {

   componentWillMount() {
      this.concepts = reachMap.concept.scenarios.map((item) => {
         return ({
            label: this.generateLabel(item.Label, item.NetworkColor),
            value: item.Value
         });
      });
   }

   generateLabel(labelText, color) {
      return (
         <div className="concept-selector__option">
            <svg height="16" width="16" className="concept-selector__color">
               <circle cx="8" cy="8" r="7" stroke="white" strokeWidth="1" fill={color} />
            </svg>
            <span>
               {labelText}
            </span>
         </div>);
   }

/**
 * renders the Concept component
 */
   render() {
      return (
         <div className="concept-selector">
            <ToggleSwitch
               options={this.concepts}
               onChange={this.props.onSelectedConcept}
               selectedValue={this.props.selectedConcept}
               displayMode="switch"/>
         </div>
      );
   }
}

Concept.propTypes = {
   /**
    * The selected concept value
    */
   selectedConcept: PropTypes.string,
   /**
    * A callback called when a concept is selected
    */
   onSelectedConcept: PropTypes.func
}

export default Concept;
